function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M229.9,473.9l19.8-19.8c4.7-4.7,4.7-12.3,0-17c0,0,0,0,0,0L69,256L249.7,74.9c4.7-4.7,4.7-12.3,0-17c0,0,0,0,0,0l-19.8-19.8 c-4.7-4.7-12.3-4.7-17,0c0,0,0,0,0,0L3.5,247.5c-4.7,4.7-4.7,12.3,0,17c0,0,0,0,0,0l209.4,209.4 C217.6,478.6,225.2,478.6,229.9,473.9z"
});

var SvgChevronL = function SvgChevronL(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ChevronL1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 512",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChevronL, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevronL.7847ec96.svg";
export { ForwardRef as ReactComponent };